import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
    collection,
    addDoc,
    getDocs,
    doc,
  } from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Start = (props) => {
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");
    const [random_group, setNum] = useState("");


    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

    useEffect(() => {
        const random_group = localStorage.getItem("random_group");
        console.log(random_group);
        setNum(random_group);
    }, []);

    async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
    });
    }
    
    var uniqueRandoms = [];
    var numRandoms = 5;
    function makeUniqueRandom() {
    // refill the array if needed
        if (!uniqueRandoms.length) {
            for (var i = 0; i < numRandoms; i++) {
                uniqueRandoms.push(i);
            }
        }
        var index = Math.floor(Math.random() * uniqueRandoms.length);
        var val = uniqueRandoms[index];
        // now remove that value from the array
        uniqueRandoms.splice(index, 1);
        return val;
    }

    const next = () => {
        const start_button = {
            time: Date.now(),
            userId: localStorage.getItem("user_id"),
            buttonType: "start_button",
        };
        addclick(start_button);

        var numRandoms = 5;
        var randomArray = [];
        for (var i = 0; i < numRandoms; i++) {
             randomArray.push(makeUniqueRandom());
        }
        console.log("g", userId);
        history(`/page${randomArray[0]}/?,${userId}`);
        randomArray.shift();
        localStorage.setItem("random_array",JSON.stringify(randomArray));
        console.log(JSON.parse(localStorage.getItem("random_array")));
    };
    
    return(
        <div className="main">
            <div className="text-center">
                <div className="content">
                        { random_group.includes("1") ? (
                            <p className="start_recommendation">
                                As noted, you will receive recommendations from a stock market expert. <br></br>
                                In earlier prediction tasks, this expert achieved a success rate of 50%. 
                            </p>
                        ) : random_group.includes("2") ? (
                            <p className="start_recommendation">
                                As noted, you will receive recommendations from a stock market expert. <br></br>
                                In earlier prediction tasks, this expert achieved a success rate of 90%. 
                            </p>
                        ) : random_group.includes("3") ? (
                            <p className="start_recommendation">
                                As noted, you will receive recommendations from an AI algorithm. <br></br>
                                In earlier prediction tasks, this algorithm achieved a success rate of 50%.
                            </p>
                        ) : (
                            <p className="start_recommendation">
                                As noted, you will receive recommendations from an AI algorithm. <br></br>
                                In earlier prediction tasks, this algorithm achieved a success rate of 90%. 
                            </p>
                        )
                        }
                    <h3 className="start">Click on the "Next" button in order to start.</h3>
                </div>
                <div>
                    <Button variant="outline-light" className="instructionsnextbutton" onClick={next}>Next</Button>
                </div>
            </div>
        </div>
    );
}